import React, { useEffect, useState } from "react";
import {
  Flex,
  Box,
  useColorModeValue,
  Divider,
  Container,
} from "@chakra-ui/react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "@emotion/styled";

import "../../../../assets/css/chargePoints.css";

import { updateConnectorDrawerState } from "atoms/updateConnectorDrawerState";
import UpdateChargePointConnectorDrawer from "../components/UpdateChargePointConnectorDrawer";
import ConnectorCard from "../../../../components/card/ConnectorCard";
import SelectEditConnector from "../components/SelectEditConnector";
import RemoteOperations from "../components/RemoteOperations";
import StartCharging from "../components/StartCharging";
import OngoingSession from "../components/OngoingSession";
import { activeConnectorState } from "atoms/activeConnectorState";
import { activeConnectorIdState } from "atoms/activeConnectorIdState";
// Glass morphism styled components
const GlassMorphismBox = styled(Box)`
  backdrop-filter: blur(16px);
  background: rgba(255, 255, 255, 0.7);
  border-radius: 20px;
  padding: 1rem;
  transition: all 0.3s ease;
  border: 1px solid rgba(35, 169, 121, 0.25);

  @media (min-width: 768px) {
    padding: 1.5rem;
  }

  &:hover {
    border-color: rgba(35, 169, 121, 0.4);
  }
`;

const Connectors = ({ data, refreshHandler }) => {
  const [activeConnector, setActiveConnector] =
    useRecoilState(activeConnectorState);
  const setActiveConnectorId = useSetRecoilState(activeConnectorIdState);
  const [count, setCount] = useState(0);
  const location = useLocation();

  // const [activeConnectorId, setActiveConnectorId] = useRecoilState(
  //   activeConnectorIdState
  // );
  const navigate = useNavigate();
  const [updateDrawerState, setUpdateDrawerState] = useRecoilState(
    updateConnectorDrawerState
  );
  const options = data.map((ele, index) => {
    return <option key={index}>{ele.EvseSerialId}</option>;
  }) || <div></div>;

  const connectorHandler = (value) => {
    console.log("connectorHandler called");
    console.log(value);
    const index = data.findIndex((obj) => obj.EvseSerialId === parseInt(value));
    console.log(index);
    if (index !== -1) {
      setActiveConnectorId(data[index].Id);
    }
  };
  const activeConnectorHandler = (conId) => {
    const index = data.findIndex((obj) => obj.EvseSerialId === parseInt(conId));
    if (index !== -1) {
      setActiveConnector(data[index]);
      setActiveConnectorId(data[index]?.Id);
    } else {
      navigate(-1);
    }
  };
  console.log(activeConnector);
  const editHandler = () => {
    setUpdateDrawerState({ isOpen: true, activeId: activeConnector?.Id });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const connectorId = searchParams.get("cid");
    if (count === 0 && data.length > 0 && connectorId) {
      activeConnectorHandler(connectorId);
      setCount((prev) => prev + 1);
    } else if (data.length > 0) {
      setActiveConnector(data[0]);
      setActiveConnectorId(data[0]?.Id);
    }
  }, [data]);

  return (
    <Flex
      flexDirection="column"
      position="relative"
      _before={{
        content: '""',
        position: "absolute",
        top: "-20px",
        left: "0",
        right: "0",
        height: "5px",
        // background:
        //   "linear-gradient(90deg, rgba(35, 169, 121, 0.2) 0%, rgba(255, 255, 255, 0) 100%)",
        zIndex: 0,
      }}
    >
      <GlassMorphismBox mb={6}>
        <SelectEditConnector
          connectorHandler={connectorHandler}
          options={options}
          editHandler={editHandler}
        />
      </GlassMorphismBox>

      <GlassMorphismBox
        mb={6}
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "3px",
          // background: "linear-gradient(90deg, #23A979 0%, #ff9966 100%)",
          zIndex: 1,
        }}
      >
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          flexWrap={{
            base: "wrap",
            md: "nowrap",
          }}
        >
          <ConnectorCard />
          {activeConnector?.Status === "Charging" ? (
            <OngoingSession refresh={refreshHandler} />
          ) : (
            <StartCharging refresh={refreshHandler} />
          )}
        </Flex>
      </GlassMorphismBox>

      <RemoteOperations
        activeConnector={activeConnector}
        refresh={refreshHandler}
      />

      {updateDrawerState?.isOpen && (
        <UpdateChargePointConnectorDrawer id={activeConnector?.id} />
      )}
    </Flex>
  );
};

export default Connectors;
